import React from 'react';
import PropTypes from 'prop-types';
import { useDocument } from 'react-firebase-hooks/firestore';
import { notification, Spin, Divider, Button, Alert, Card, Avatar } from 'antd';
import { Formik } from 'formik';
import { Form, InputNumber, FormItem } from 'formik-antd';
import { useHistory } from 'react-router-dom';

import { ROUTE_EMPLOYER_PREFIX } from 'utils/routes';
import Client from 'containers/app/client';

const { Meta } = Card;

const initialValues = {
  amount: 1,
};

// const bundles = [1, 10, 20, 50, 100];

const UserItem = ({ uid }) => {
  const history = useHistory();
  const ref = Client.dbDoc(`users/${uid}`);
  const [doc, loading, error] = useDocument(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  const { info, tokens = 0 } = doc.data();

  const { photoURL, firstName, lastName } = info;

  const handleSubmit = async (values, { setStatus, setSubmitting }) => {
    const { amount } = values;
    setSubmitting(true);
    try {
      await Client.transferTokens({ amount, to: uid });
      notification.success({
        title: 'Token sent!',
        message: `${values.amount} Tokens sent to ${firstName} ${lastName}.`,
      });
      setSubmitting(false);
      history.push(`${ROUTE_EMPLOYER_PREFIX}/dashboard`);
    } catch (err) {
      setSubmitting(false);
      setStatus({ message: err.message, type: 'error' });
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ isSubmitting, status, setStatus }) => {
        return (
          <Form layout="vertical" className="wrapper">
            <Card
              actions={[
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Send Tokens
                </Button>,
              ]}
            >
              <Meta
                avatar={<Avatar size="large" src={photoURL} />}
                title={`${firstName} ${lastName}`}
                description={`${tokens}`}
              />

              <Divider />

              {status != null ? (
                <>
                  <Alert
                    closable
                    message={status.message}
                    type={status.type}
                    onClose={() => {
                      setStatus(undefined);
                    }}
                  />
                  <Divider />
                </>
              ) : null}
              <FormItem
                name="amount"
                label="How many tokens would you like to send?"
              >
                {/* <Radio.Group name="amount">
                  {bundles.map((bundle, i) => (
                    <Radio.Button key={i} value={bundle}>
                      {bundle}
                    </Radio.Button>
                  ))}
                </Radio.Group> */}
                <InputNumber name="amount" />
              </FormItem>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

UserItem.propTypes = {
  uid: PropTypes.string.isRequired,
};

UserItem.defaultProps = {};

export default UserItem;
